import listQuery from 'graphql/queries/diary/DiaryResultListQuery.graphql';
import fragment from 'graphql/fragments/diary/DiaryResultFragment.graphql';

const Result = {
  type: 'Result',
  title: 'Task Results',
  formTitle: 'Task Result',
  formUrl: '/Diary/Result/Details/',
  workspaceUrl: '/Diary/Result/Workspace/',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
};

export default Result;
